import React from 'react';
import { Table } from 'react-bootstrap';

const DataTable = ({ headers, data, renderRow }) => {
  return (
    <div className="table-responsive">
      <Table striped bordered hover className="mt-4">
        <thead className="bg-primary text-white">
          <tr>
            {headers.map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => renderRow(row, index))}
        </tbody>
      </Table>
    </div>
  );
};

export default DataTable; 